import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { WorkOrderContext } from '../context/WorkOrderContext';

export default function CFIInformationPanel() {

	const { order } = useContext(WorkOrderContext);

	return (
		<>
			<Panel
				header={'CFI Information'}
				className="field-label-30"
			>
				<Field label={'Company'} >{order.details.cfiCompanyName}</Field>
				<Field label={'Address'} >{order.details.cfiAddress1}</Field>
				<Field label={''} visible={!!order.details.cfiAddress2}>{order.details.cfiAddress2}</Field>
				<Field label={''} >{order.details.cfiCity}, {order.details.cfiState} {order.details.cfiZip}</Field>
				<Field label={'Office'} >{order.details.cfiPhone}</Field>
				<Field label={'Fax'} >{order.details.cfiFax}</Field>
				<Field label={'Email'} >{order.details.cfiEmail}</Field>
			</Panel>
		</>
	);
}
